import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
// routes
import { PATH_AUTH_LINGUIST } from '../../../routes/paths';
// layout
import AuthPortalLayout from '../../../layouts/auth/AuthPortalLayout';
import {
  AUTH_PORTALS,
  authSecondaryButtonSx
} from '../../../layouts/auth/portals';
// universe
import { UNIVERSE_FONT, hairlineOf } from '../../../theme/universe/brand';
// sections
import { LoginForm } from '../../../sections/auth/linguistAuth/login';

// ----------------------------------------------------------------------

const PORTAL = AUTH_PORTALS.vendor;

// The portal is named in the title, as the intranet's is ("Sign in to
// Intranet"), by the name the portal chooser and the other portals' "Not your
// portal?" links give it; the line under it says how, not where, again.
export const VENDOR_SIGN_IN = {
  title: `Sign in to ${PORTAL.label}`,
  subtitle: 'Use the email and password of your LingoYou vendor account.'
};

export default function Login() {
  const theme = useTheme();
  return (
    <AuthPortalLayout
      portal={PORTAL}
      title={VENDOR_SIGN_IN.title}
      subtitle={VENDOR_SIGN_IN.subtitle}
    >
      <LoginForm />

      {/* Recruiting linguists is the point of this portal, so the way in for
          a newcomer is its own section with its own button — not a text link
          under the form. It is a SECTION of the card (a hairline, a title, a
          sentence, the secondary button), not a second card inside it:
          DESIGN.md §7 puts no sheet inside a sheet, and the violet rule the
          first cut drew here was the old portal colour, outside the system.
          Secondary, so it never competes with Sign in above it. */}
      <Box
        component="section"
        aria-labelledby="vendor-join-title"
        sx={{ mt: 4, pt: 3, borderTop: `1px solid ${hairlineOf(theme)}` }}
      >
        <Typography
          id="vendor-join-title"
          component="h2"
          sx={{
            m: 0,
            fontFamily: UNIVERSE_FONT,
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.3,
            color: 'text.primary'
          }}
        >
          New to LingoYou?
        </Typography>
        <Typography
          sx={{
            mt: 0.75,
            mb: 2,
            fontFamily: UNIVERSE_FONT,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.5,
            color: 'text.secondary'
          }}
        >
          Join our network of translators, interpreters and mediators: find
          work, manage your projects and get paid, all in one place. Creating
          the account takes a few minutes.
        </Typography>

        <Button
          fullWidth
          size="large"
          variant="outlined"
          component={RouterLink}
          to={PATH_AUTH_LINGUIST.register}
          sx={authSecondaryButtonSx}
        >
          Create a vendor account
        </Button>
      </Box>
    </AuthPortalLayout>
  );
}
